import { render, staticRenderFns } from "./logos-comp.vue?vue&type=template&id=00937f22&scoped=true"
import script from "./logos-comp.vue?vue&type=script&lang=js"
export * from "./logos-comp.vue?vue&type=script&lang=js"
import style0 from "./logos-comp.vue?vue&type=style&index=0&id=00937f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00937f22",
  null
  
)

export default component.exports